import { CommissionPaymentType } from '../sdk/sdk';

export const SELECTABLE_COMMISSION_PAYMENT_TYPES: CommissionPaymentType[] = [
  CommissionPaymentType.Initial,
  CommissionPaymentType.Final,
  CommissionPaymentType.CancelledContract,
  CommissionPaymentType.RescopeAdjustment,
  CommissionPaymentType.AccountsReceivableClawback,
];
